import { NAVIGATION } from '../../config/index';
import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';
import { navigation } from '../../utils/index';
import { deleteProject } from '../actions/project';
import { Dispatch, GetState } from '../redux.types';

export const navigateToProjects =
  () => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const organizationId = getSelectedOrganizationId(state);
    navigation.goToPath(NAVIGATION.PROJECTS_STATE, { organizationId });
  };

export const PROJECT_OVERVIEW_ACTION_NAMES = {
  SHOW_PROJECT_DELETE_MODAL:
    'PROJECT_OVERVIEW_ACTION_NAMES__SHOW_PROJECT_DELETE_MODAL',
  HIDE_PROJECT_DELETE_MODAL:
    'PROJECT_OVERVIEW_ACTION_NAMES__HIDE_PROJECT_DELETE_MODAL',
  SHOW_ADD_FLOW_IN_SIDEBAR:
    'PROJECT_OVERVIEW_ACTION_NAMES__SHOW_ADD_FLOW_IN_SIDEBAR',
  HIDE_ADD_FLOW_IN_SIDEBAR:
    'PROJECT_OVERVIEW_ACTION_NAMES__HIDE_ADD_FLOW_IN_SIDEBAR',
  SHOW_ADD_REPLICATION_IN_SIDEBAR:
    'PROJECT_OVERVIEW_ACTION_NAMES__SHOW_ADD_REPLICATION_IN_SIDEBAR',
  HIDE_ADD_REPLICATION_IN_SIDEBAR:
    'PROJECT_OVERVIEW_ACTION_NAMES__HIDE_ADD_REPLICATION_IN_SIDEBAR',
};

export const showProjectDeleteModal = () => ({
  type: PROJECT_OVERVIEW_ACTION_NAMES.SHOW_PROJECT_DELETE_MODAL,
  payload: undefined,
});

export const hideProjectDeleteModal = () => ({
  type: PROJECT_OVERVIEW_ACTION_NAMES.HIDE_PROJECT_DELETE_MODAL,
  payload: undefined,
});

export const deleteProjectAndNavigate = () => (dispatch: Dispatch) => {
  dispatch(hideProjectDeleteModal());

  dispatch<Promise<void>>(deleteProject()).then(() => {
    dispatch(navigateToProjects());
  });
};

export const showProjectOverviewAddFlowInSidebar = () => ({
  type: PROJECT_OVERVIEW_ACTION_NAMES.SHOW_ADD_FLOW_IN_SIDEBAR,
  payload: undefined,
});

export const hideProjectOverviewAddFlowInSidebar = () => ({
  type: PROJECT_OVERVIEW_ACTION_NAMES.HIDE_ADD_FLOW_IN_SIDEBAR,
  payload: undefined,
});

export const showProjectOverviewAddReplicationInSidebar = () => ({
  type: PROJECT_OVERVIEW_ACTION_NAMES.SHOW_ADD_REPLICATION_IN_SIDEBAR,
  payload: undefined,
});

export const hideProjectOverviewAddReplicationInSidebar = () => ({
  type: PROJECT_OVERVIEW_ACTION_NAMES.HIDE_ADD_REPLICATION_IN_SIDEBAR,
  payload: undefined,
});
